module.exports = __webpack_public_path__ + "static/media/icon-supplies-pumice.378cd8c0.svg";